import React from "react";

import { CardList } from "../../Card/index";
const CardCategoriesList = () => {
  return <CardList itemOnRow={3} itemOnPage={12} />;
};

export default CardCategoriesList;
